import { CreateResponsiveStyle, DEVICE_SIZES, maxSize } from "rn-responsive-styles";
import colors from "@assets/colors";

const useStyles = CreateResponsiveStyle(
  {
    flex1: { flex: 1 },
    header_container: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
      marginBottom: 25,
    },
    signDrawText: {
      paddingLeft: 5,
      color: colors.black2,
      fontFamily: "DMSans",
      fontWeight: "400",
      fontSize: 20,
      lineHeight: 25,
    },
    v_signature_canvas: {
      width: "100%",
      height: 240,
      alignItems: "center",
      justifyContent: "center",
      borderWidth: 1,
      borderColor: '#A3A3A3',
      borderRadius: 5,
      backgroundColor: "#F9F9F9", //"#ECF3FF",
    },
    signBtnV: {
      width: "100%",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 30,
    },
    disabledAutoFocus: {
      position: 'absolute',
      opacity: 0,
    },
    labelReset: {
      fontSize: 16,
      fontWeight: 'bold',
      color: colors.black3,
    },
    btnReset: {
      top: 12,
      width: "20%",
      backgroundColor: colors.white,
      marginRight: 5,
    },
    btnCancel: {
      width: "30%",
      borderWidth: 1,
      marginRight: 12,
      borderColor: colors.purple,
      backgroundColor: colors.white,
    },
    btnSign: {
      width: "30%",
      backgroundColor: colors.colorPrimary
    },
  },
  {
    [DEVICE_SIZES.XL]: {
      btnReset: {
        width: "13%",
        marginRight: 0,
      },
    },
    [DEVICE_SIZES.LG]: {
      signDrawText: {
        fontSize: 16,
        lineHeight: 21,
      },
      labelReset: {
        fontSize: 14,
      },
      btnReset: {
        width: "20%",
        right: -15,
      },
    },
    [DEVICE_SIZES.MD]: {
      btnReset: {
        marginRight: 20,
      },
    },
    [maxSize(DEVICE_SIZES.SM)]: {
      flex1: { marginTop: 30 },
      v_signature_canvas: {
        height: 350,
      },
    },
  }
);

export default useStyles;
